<app-dialog (actionButtonClicked)="onFormSubmit($event)" [config]="data.config">
    <ng-container dialog-title>Change Bulk Status</ng-container>

    <ng-container *ngIf="paymentStatusesForm && paymentStatusesForm.formGroup" dialog-process-in-progress>
        <form [formGroup]="paymentStatusesForm.formGroup" class="row add-exchange-form">
            <div [ngClass]="{'mb-3': paymentStatusesForm.controls[0].errors?.length > 0}" class="col-12">
                <app-select [control]="paymentStatusesForm.controls[0]"
                    [formControlName]="paymentStatusesForm.controls[0].name"></app-select>
            </div>
            <div [ngClass]="{'mb-3': paymentStatusesForm.controls[1].errors?.length > 0}" class="col-12">
                <app-textarea [control]="paymentStatusesForm.controls[1]"
                    [formControlName]="paymentStatusesForm.controls[1].name"></app-textarea>
            </div>
            <div class="col-12 pr-0 pl-0 mt-4">
                <div class="row  no-gutters">
                    <div class="col-6">
                        <p class="mb-0 col-6"> Number of Payments: </p>
                    </div>
                    <div class="col-6 align-items-center font-weight-bold justify-content-between">
                        <p class="mb-0 col-6">{{numberOfPayment}}</p>
                    </div>
                </div>
            </div>
            <div class="col-12 pr-0 pl-0 mt-4" *ngIf="totalGroups && totalGroups.length > 0">
                <div class="row  no-gutters">
                    <div class="col-6">
                        <p class="mb-0 col-6"> Total Amount : </p>
                    </div>
                    <div class="col-6 align-items-center font-weight-bold justify-content-between">
                        <div class="row no-gutters" *ngFor="let item of totalGroups">
                            <p class="mb-0 col-6">{{item.amount | formatMultiCurrency:'':6:2:false}}</p>
                            <p class="mb-0 col-6">{{item.currency.toUpperCase()}}</p>
                        </div>

                    </div>
                </div>
            </div>
        </form>
    </ng-container>
</app-dialog>